/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChartNoAxesColumnIncreasing = [
  "svg",
  defaultAttributes,
  [
    ["line", { x1: "12", x2: "12", y1: "20", y2: "10" }],
    ["line", { x1: "18", x2: "18", y1: "20", y2: "4" }],
    ["line", { x1: "6", x2: "6", y1: "20", y2: "16" }]
  ]
];

export { ChartNoAxesColumnIncreasing as default };
//# sourceMappingURL=chart-no-axes-column-increasing.js.map
